function getQueryStringParameters() {
  var parameters = {},
    hash;
  var q = document.URL.split("?")[1];
  if (q != undefined) {
    q = q.split("&");
    for (var i = 0; i < q.length; i++) {
      hash = q[i].split("=");
      parameters[hash[0]] = hash[1];
    }
  }
  return parameters;
}

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

/**
 * This function takes the cart level attributes and custom line item properties and
 * appends them to the form data in the format required for them to show up on the
 * checkout page.
 *
 * @param {*} parameters The cart level attributes to add to the form data.
 * @param {*} properties The custom line item properties to add to the form data.
 * @param {*} formData The form data to populate with the cart level attributes and custom line item properties.
 * @returns The form data with the cart level attributes and custom line item properties added.
 */
function populateCartAttributesAndPropertyData(parameters, properties, formData) {
  if (isEmpty(parameters) == false) {
    const entries = Object.entries(parameters);

    // Handle cart level attributes
    entries.map(([key, val] = entry) => {
      // apend these to the cart attributes
      // janky, solve at root!
      // This code removes url encoding for the forward slash character.
      val = val.replace(/%2F/gi, "/");
      formData.append("attributes[" + key + "]", val);
    });
  }

  // Handle custome line item properties
  if (isEmpty(properties) == false) {
    const entries = Object.entries(properties);

    entries.map(([key, val] = entry) => {
      // apend these to the cart attributes
      // janky, solve at root!
      // This code removes url encoding for the forward slash character.
      val = val.replace(/%2F/gi, "/");
      formData.append("properties[" + key + "]", val);
    });
  }
  return formData;
}

/**
 * Formats an ISO date string (e.g., '2025-08-04T09:46:15.153564Z') to dd/mm/yyyy.
 * @param {string} isoDate - ISO date string.
 * @returns {string} Formatted date as dd/mm/yyyy (e.g., '04/08/2025').
 */
function formatDateToDDMMYYYY(isoDate) {
  try {
    const date = new Date(isoDate);
    if (isNaN(date.getTime())) {
      console.error("Invalid date:", isoDate);
      return "Invalid Date";
    }

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getUTCFullYear();

    const formattedDate = `${day}/${month}/${year}`;

    return formattedDate;
  } catch (error) {
    console.error("Error formatting date:", isoDate, error);
    return "Invalid Date";
  }
}

/**
 * Updates a usage circle's SVG ring and text based on allowance data.
 * @param {HTMLElement} container - The parent element (esim_card_2).
 * @param {string} type - Allowance type ('data', 'voice', 'sms').
 * @param {Object} allowance - Allowance object with unlimited, initialAmount, remainingAmount.
 * @param {string} unit - Unit for display ('GB', 'Mins', 'SMS').
 * @param {number} sizeOfAGigabyte - Size of a gigabyte (default: 1000000000).
 */
function updateUsageCircle(container, type, allowance, unit, circleNumber, sizeOfAGigabyte = 1000000000) {
  const unlimited = allowance.unlimited;
  const initialAmount = new MobileData(allowance.initialAmount).gigabytes(sizeOfAGigabyte);
  const remainingAmount = new MobileData(allowance.remainingAmount).gigabytes(sizeOfAGigabyte);

  let circleNumberString = "";
  if (circleNumber) {
    circleNumberString = "_" + circleNumber;
  }

  container.querySelector(`#esim_${type}_status${circleNumberString}`).style.cssText =
    "display: inline-block !important;";

  const usageText = container.querySelector(`#esim_${type}_usage_text${circleNumberString}`);
  const totalText = container.querySelector(`#esim_${type}_total_text${circleNumberString}`);
  const unlimitedEl = container.querySelector(`#esim_${type}_unlimited${circleNumberString}`);
  const remainingBorder = container.querySelector(`#esim_${type}_border_remaining${circleNumberString}`);
  const usedBorder = container.querySelector(`#esim_${type}_border_used${circleNumberString}`);

  if (!usageText || !totalText || !unlimitedEl || !remainingBorder || !usedBorder) {
    console.error(`${type.toUpperCase()} - Elements not found:`, {
      usageText,
      totalText,
      unlimitedEl,
      remainingBorder,
      usedBorder,
    });
    return;
  }

  // Get radius from SVG circle's 'r' attribute
  const radius = parseFloat(remainingBorder.getAttribute("r")) || 47;

  const circumference = 2 * Math.PI * radius;

  if (unlimited) {
    usageText.style.display = "none";
    totalText.style.display = "none";
    unlimitedEl.style.cssText = "display: flex !important";

    remainingBorder.setAttribute("stroke-dasharray", `${circumference} ${circumference}`); // Full green ring
    usedBorder.style.display = "none"; // Hide red ring
  } else {
    usageText.textContent = `${remainingAmount.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })} ${unit}`;
    totalText.textContent = `left of ${initialAmount} ${unit}`;

    const remainingPercentage = (remainingAmount / initialAmount) * 100;
    const usedPercentage = 100 - remainingPercentage;
    const usedDash = (usedPercentage / 100) * circumference;
    const remainingDash = (remainingPercentage / 100) * circumference;

    usedBorder.setAttribute("stroke-dasharray", `${usedDash} ${circumference}`);
    remainingBorder.setAttribute("stroke-dasharray", `${remainingDash} ${circumference}`);
    remainingBorder.setAttribute("stroke-dashoffset", `-${usedDash}`);
  }
}

function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName;

  for (let i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
}

function getUTMParams() {
  const utmParams = new URLSearchParams();
  const utmSource = sessionStorage.getItem("utm_source");
  const utmMedium = sessionStorage.getItem("utm_medium");
  const utmCampaign = sessionStorage.getItem("utm_campaign");

  if (utmSource) {
    utmParams.set("utm_source", utmSource);
  }
  if (utmMedium) {
    utmParams.set("utm_medium", utmMedium);
  }
  if (utmCampaign) {
    utmParams.set("utm_campaign", utmCampaign);
  }

  return utmParams;
}

/// Remove attributes from the cart
async function clearCartAndCheckout(config, bypassCartPage) {
  // Ensure bypassCartPage is a boolean
  const shouldBypassCart = bypassCartPage === true || bypassCartPage === "true";

  const promise1 = (async () => {
    try {
      const response = await fetch("/cart.js", {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });
      const resp = await response.json();
      var nullHash = {};
      for (const [key, value] of Object.entries(resp.attributes)) {
        nullHash[key] = null;
      }
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ attributes: nullHash }),
      });
    } catch (error) {
      console.error("Error updating cart attributes:", error);
    }
  })();

  const promise2 = fetch("/cart/clear.json", {
    method: "POST",
    headers: {
      Accept: "application/json",
    },
  });

  try {
    await Promise.all([promise1, promise2]);

    // Get cart drawer or notification for sections (if cart_type is drawer or notification)
    const cartDrawer = document.querySelector("cart-drawer");
    const cartNotification = document.querySelector("cart-notification");
    const cartElement = cartDrawer || cartNotification;
    
    // Append sections to formData if cart drawer/notification exists (for cart updates)
    if (cartElement && cartElement.getSectionsToRender && config.body instanceof FormData) {
      const sections = cartElement.getSectionsToRender().map((section) => section.id);
      if (sections.length > 0) {
        config.body.append("sections", sections.join(","));
        config.body.append("sections_url", window.location.pathname);
      }
    }

    const response = await fetch(`${routes.cart_add_url}`, config);
    const data = await response.json();

    if (data.status && data.status !== 200) {
      if (this && this.handleErrorMessage) {
        this.handleErrorMessage(data.description);
      }
      const soldOutMessage = document.querySelector(".sold-out-message");
      if (soldOutMessage) {
        const submitButton = document.querySelector(".product-form__submit");
        if (submitButton) {
          submitButton.setAttribute("aria-disabled", "true");
          submitButton.querySelector("span")?.classList.add("hidden");
        }
        soldOutMessage.classList.remove("hidden");
      }
      
      // Reset loading state on error
      const buttons = document.querySelectorAll(".buy-now-button, .add-to-cart-button");
      buttons.forEach((button) => {
        button.classList.remove("loading");
        button.disabled = false;
      });
      
      return;
    }

    // Wait a moment to ensure cart operations complete
    await new Promise((resolve) => setTimeout(resolve, 300));

    // Reset loading state before redirecting or opening cart
    const buttons = document.querySelectorAll(".buy-now-button, .add-to-cart-button");
    buttons.forEach((button) => {
      button.classList.remove("loading");
      button.disabled = false;
    });

    // If bypassing cart, go straight to checkout
    if (shouldBypassCart) {
      const utmParams = getUTMParams();
      let checkoutUrl = "/checkout";
      if (utmParams.size > 0) {
        checkoutUrl += `?${utmParams.toString()}`;
      }

      try { sessionStorage.removeItem("topUpIccid"); } catch (err) {}

      // default localization does not need to be in URL
      if (typeof Shopify !== "undefined" && Shopify.locale && Shopify.locale != "en") {
        const redirectUrl = (typeof locale_root !== "undefined" ? locale_root : "") + checkoutUrl;
        window.location.href = redirectUrl;
        return;
      }

      window.location.href = checkoutUrl;
      return;
    }

    // Not bypassing cart - respect cart_type setting
    // Reuse cartDrawer and cartNotification variables declared earlier
    // Check for cart drawer first (cart_type === 'drawer')
    if (cartDrawer && cartDrawer.renderContents && data.sections) {
      // Update cart drawer with sections data from response (includes items AND subtotal/footer)
      // This updates the entire cart drawer including the footer with subtotal
      cartDrawer.renderContents(data);
      
      // Publish cart update event for other components (product-info for quantity rules, etc.)
      // Note: CartDrawerItems subscribes to this, but we've already updated via renderContents above
      // The overridden onCartUpdate in CartDrawerItems fetches the correct section, but since
      // we've already rendered, it will just update the items list (which is fine, no duplicates)
      if (typeof publish !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "buy-now" });
      }
      
      // renderContents already calls open() internally, so we don't need to call it again
      return;
    }

    // Check for cart notification (cart_type === 'notification')
    if (cartNotification && cartNotification.renderContents) {
      // Update cart notification with new cart data
      cartNotification.renderContents(data);
      
      // Publish cart update event for other components
      if (typeof publish !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "buy-now" });
      }
      
      // Open cart notification
      if (cartNotification.open) {
        cartNotification.open();
      }
      return;
    }

    // Fallback: redirect to cart page (cart_type === 'page' or neither drawer/notification exists)
    const utmParams = getUTMParams();
    let cartUrl = "/cart";
    if (utmParams.size > 0) {
      cartUrl += `?${utmParams.toString()}`;
    }

    // default localization does not need to be in URL
    if (typeof Shopify !== "undefined" && Shopify.locale && Shopify.locale != "en") {
      const redirectUrl = (typeof locale_root !== "undefined" ? locale_root : "") + cartUrl;
      window.location.href = redirectUrl;
      return;
    }

    window.location.href = cartUrl;
  } catch (e) {
    console.error("Error in clearCartAndCheckout:", e);
    
    // Reset loading state on error
    const buttons = document.querySelectorAll(".buy-now-button, .add-to-cart-button");
    buttons.forEach((button) => {
      button.classList.remove("loading");
      button.disabled = false;
    });
  }
}

// Remove all items from cart before adding new items
async function emptyCart() {
  try {
    await fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: "",
    });
  } catch (error) {
    console.log("error clearing cart");
  }
}

// Adds a product to cart without clearing existing items
async function addToCartWithoutClearing(config, openCartDrawer) {
  try {
    // Get cart drawer if it exists
    const cartDrawer = document.querySelector("cart-drawer");
    
    // Append sections to formData if cart drawer exists (for cart drawer updates)
    if (cartDrawer && cartDrawer.getSectionsToRender && config.body instanceof FormData) {
      const sections = cartDrawer.getSectionsToRender().map((section) => section.id);
      if (sections.length > 0) {
        config.body.append("sections", sections.join(","));
        config.body.append("sections_url", window.location.pathname);
      }
    }

    const response = await fetch(`${routes.cart_add_url}`, config);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();

    // Check for errors - if status exists, it's an error
    if (data.status) {
      // Handle error
      const errorMessageWrapper = document.querySelector(".product-form__error-message-wrapper");
      if (errorMessageWrapper) {
        const errorMessage = errorMessageWrapper.querySelector(".product-form__error-message");
        if (errorMessage) {
          errorMessage.textContent = data.description || "An error occurred";
        }
        errorMessageWrapper.removeAttribute("hidden");
      }
      
      const soldOutMessage = document.querySelector(".sold-out-message");
      if (soldOutMessage) {
        const submitButton = document.querySelector(".product-form__submit");
        if (submitButton) {
          submitButton.setAttribute("aria-disabled", "true");
          const buttonSpan = submitButton.querySelector("span");
          if (buttonSpan) {
            buttonSpan.classList.add("hidden");
          }
        }
        soldOutMessage.classList.remove("hidden");
      }
      
      // Stop loading
      const buttons = document.querySelectorAll(".buy-now-button, .add-to-cart-button");
      buttons.forEach((button) => {
        button.classList.remove("loading");
        button.disabled = false;
      });
      
      return;
    }

    // Update cart drawer with sections data from response (includes items AND subtotal/footer)
    // This updates the entire cart drawer including the footer with subtotal
    if (cartDrawer && cartDrawer.renderContents && data.sections) {
      cartDrawer.renderContents(data);
    }

    // Publish cart update event for other components (product-info for quantity rules, etc.)
    // Note: CartDrawerItems subscribes to this, but we've already updated via renderContents above
    // The overridden onCartUpdate in CartDrawerItems fetches the correct section, but since
    // we've already rendered, it will just update the items list (which is fine, no duplicates)
    if (typeof publish !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: "buy-buttons" });
    }

    // Wait a moment to ensure cart operations complete
    await new Promise((resolve) => setTimeout(resolve, 300));

    // Open cart drawer if requested
    if (openCartDrawer && cartDrawer) {
      if (cartDrawer.open) {
        cartDrawer.open();
      } else {
        // Fallback: click cart button
        const cartButton = document.querySelector(".header__icon--cart");
        if (cartButton) {
          cartButton.click();
        }
      }
    }

    // Stop loading
    const buttons = document.querySelectorAll(".buy-now-button, .add-to-cart-button");
    buttons.forEach((button) => {
      button.classList.remove("loading");
      button.disabled = false;
    });
  } catch (e) {
    console.error("Error adding item to cart:", e);
    
    // Stop loading on error
    const buttons = document.querySelectorAll(".buy-now-button, .add-to-cart-button");
    buttons.forEach((button) => {
      button.classList.remove("loading");
      button.disabled = false;
    });
  }
}

// Builds form data with all metadata for cart operations
function buildCartFormData(variantID, quantityToAdd, sellingPlanId) {
  // Parse quantity and ensure it's a valid positive number
  const parsedQty = parseInt(quantityToAdd, 10);
  if (!isNaN(parsedQty) && parsedQty > 0) {
    quantityToAdd = parsedQty;
  } else {
    quantityToAdd = 1;
  }

  const config = fetchConfig("javascript");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  delete config.headers["Content-Type"];

  let formData = new FormData();
  formData.append("quantity", quantityToAdd);
  formData.append("form_type", "product");
  formData.append("id", variantID);

  if (sellingPlanId) {
    // Ensure selling plan ID is a valid number
    const planId = parseInt(sellingPlanId, 10);
    if (!isNaN(planId)) {
      formData.append("selling_plan", planId);
    } else {
      console.warn("⚠️ Invalid selling plan ID:", sellingPlanId);
    }
  }

  // get any query string parameters, are we topping up an existing iccid?
  let parameters = {};

  if (sessionStorage.getItem("topUpIccid")) {
    parameters.iccid = sessionStorage.getItem("topUpIccid");
    sessionStorage.removeItem("topUpIccid");
  }

  let properties = {};

  // get the stored donation organisation from the session storage if it exists
  if (sessionStorage.getItem("donationOrganisation")) {
    properties.donationOrganisation = sessionStorage.getItem("donationOrganisation");
    // Remove it so it doesn't get repeatedly added to future orders
    sessionStorage.removeItem("donationOrganisation");
  }

  if (Shopify.locale !== null) {
    parameters.userLanguage = Shopify.locale;
  } else {
    parameters.userLanguage = "en";
  }

  let checkoutUserAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (checkoutUserAgent) {
    parameters.userAgent = checkoutUserAgent;
  }

  if (deviceInfo) {
    parameters.deviceInfo = JSON.stringify(deviceInfo);
  }

  let tripDurationVal = sessionStorage.getItem("tripDuration");
  if (tripDurationVal > 0) {
    if (tripDurationVal == 1) {
      parameters.tripDuration = `${tripDurationVal} day`;
    } else {
      parameters.tripDuration = `${tripDurationVal} days`;
    }
  }

  // populate attributes from utils fn
  formData = populateCartAttributesAndPropertyData(parameters, properties, formData);

  config.body = formData;
  return config;
}

// Adds a product to cart without clearing existing items (for Add to Cart button)
function addItemToCart(variantID, quantityToAdd, openCartDrawer, sellingPlanId) {
  const config = buildCartFormData(variantID, quantityToAdd, sellingPlanId);
  return addToCartWithoutClearing(config, openCartDrawer);
}

// Adds a product (for Buy Now button) - optionally clears cart first
function buyNowAddToCart(variantID, quantityToAdd, bypassCartPage, sellingPlanId, clearCart = true) {
  const config = buildCartFormData(variantID, quantityToAdd, sellingPlanId);
  
  // If clearCart is false, add to cart without clearing (like Add to Cart)
  if (!clearCart) {
    // Determine if we should open cart drawer based on cart_type setting
    // For Buy Now, we typically want to show the cart, but respect skipCart setting
    const shouldOpenCart = !bypassCartPage;
    return addToCartWithoutClearing(config, shouldOpenCart);
  }
  
  // Default behavior: clear cart and add item
  clearCartAndCheckout(config, bypassCartPage);
}

function localisationSearch(listId, inputId) {
  let countryList = document.getElementById(listId);

  if (countryList) {
    document.getElementById(inputId).addEventListener("input", function () {
      let filter = this.value.toLowerCase();
      Array.from(countryList.children).forEach((item) => {
        if (item.textContent.toLocaleLowerCase().includes(filter)) {
          item.style.display = "";
        } else {
          item.style.display = "none";
        }
      });
    });
  }
}
